const defaultState = {
  page: 1,
  minis: []
}

const catalogReducer = (state = defaultState, action) => {
  return state
}

export default catalogReducer